import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false, // assuming the user is NOT authenticated by default
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setIsAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload;
    },
  }
}
);

export const { redirectUI, setIsAuthenticated } = authSlice.actions;
export default authSlice.reducer